import type { QueueManagedItem } from "@packages/sdk";

import { useQueue } from "./useQueue";

export const useCurrentQueueItem = () => {
  const queue = useQueue();
  const currentItem: QueueManagedItem | null = queue.currentItem ?? null;
  return { queue, currentItem };
};
